// import React from "react";
import "./BlackberryBlogs.scss";
import { FaCalendarAlt, FaUser } from "react-icons/fa";

const BlackberryBlogs = () => {
  const blogs = [
    {
      id: 1,
      image: "/assets/img/elnora/24.png",
      title: "The Evolution of Fashion",
      excerpt:
        "Exploring the journey of ethnic fashion through the decades and its impact on modern style.",
      date: "March 15, 2024",
      author: "John Smith",
    },
    {
      id: 2,
      image: "/assets/img/elnora/32.png",
      title: "Essential Wardrobe Pieces",
      excerpt:
        "Discover the timeless pieces every man should have in his wardrobe for a versatile style.",
      date: "March 12, 2025",
      author: "Emma Wilson",
    },
    {
      id: 3,
      image: "/assets/img/elnora/31.png",
      title: "Sustainable Fashion Guide",
      excerpt:
        "How to make conscious fashion choices while maintaining your personal style.",
      date: "March 10, 2025",
      author: "Michael Brown",
    },
  ];

  return (
    <section className="bb-blogs">
      <div className="bb-blogs-container">
        <div className="bb-blogs-header">
          <h2>NEWS & ARTICLES</h2>
          <p>FROM THE BLOG</p>
        </div>

        <div className="bb-blogs-grid">
          {blogs.map((blog) => (
            <article key={blog.id} className="bb-blog-card">
              <div className="blog-image">
                <img src={blog.image} alt={blog.title} />
              </div>
              <div className="blog-content">
                <h3>{blog.title}</h3>
                <p className="blog-excerpt">{blog.excerpt}</p>
                <div className="blog-meta">
                  <span className="blog-date">
                    <FaCalendarAlt />
                    {blog.date}
                  </span>
                  <span className="blog-author">
                    <FaUser />
                    {blog.author}
                  </span>
                </div>
                <a href="#" className="read-more">
                  Read More
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="bb-blogs-button">
          <button className="bb-blogs-button-primary">VIEW ALL</button>
        </div>
      </div>
    </section>
  );
};

export default BlackberryBlogs;
